<template>
  <div>
    <div style="float: right" v-if="campaignList.length != 0">
      <span style="color: green">*Enabled</span>
      <span style="color: #ffaa1d; padding-left: 10px; padding-right: 10px"
        >*Paused</span
      >
      <span style="color: #ccc">*Archived</span>
    </div>
    <table
      v-if="campaignList.length != 0"
      class="table"
      style="table-layout:fixed;"
    >
      <thead style="position: sticky;">
        <tr>
          <th class="text-center" style="width:3%">
            <input v-model="actionSelectionControl" type="checkbox" />
          </th>
          <th class="link" v-on:click="sorting('state', $event)" style="width:5%">
            Status
            <i
              class="sort fa"
              :class="
                sort.field == 'state'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <th
            class="link"
            v-on:click="sorting('name', $event)"
            style="width:20%"
          >
            Name
            <i
              class="sort fa"
              :class="
                sort.field == 'name'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <!-- <th class="link" v-on:click="sorting('type', $event)">
            Type
            <i
              class="sort fa"
              :class="
                sort.field == 'type'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th> -->
          <th>Tags</th>
          <th>Country</th>
          <th>Start Date</th>
          <!-- <th>End Date</th> -->
          <th class="link" v-on:click="sorting('dBudget', $event)">
            D Budget($)
            <i
              class="sort fa"
              :class="
                sort.field == 'dBudget'
                  ? sort.order == 'asc'
                    ? 'fa-arrow-up'
                    : 'fa-arrow-down'
                  : ''
              "
            ></i>
          </th>
          <!--
						<th class="link" v-on:click="sorting('impressions',$event)">
						Impressions
						<i
							class="sort fa"
							:class="sort.field=='impressions'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
						></i>
					</th> 
					<th class="link" v-on:click="sorting('clicks',$event)">
						Clicks
						<i
							class="sort fa"
							:class="sort.field=='clicks'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
						></i>
					</th>
					<th>
						aCPC
						<i class="sort fa"></i>
					</th>
					<th class="link" v-on:click="sorting('spend',$event)">
						Spend($)
						<i
							class="sort fa"
							:class="sort.field=='spend'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
						></i>
					</th>
					<th class="link" v-on:click="sorting('estSales',$event)">
						Est Sales
						<i
							class="sort fa"
							:class="sort.field=='estSales'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
						></i>
					</th>
					
					<th class="link" v-on:click="sorting('acos',$event)">
						ACoS
						<i
							class="sort fa"
							:class="sort.field=='acos'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
						></i>
					</th>
					-->
          <th>Search Specialist</th>
          <th>Shut Off</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in campaignList"
          :key="item.name + '_' + index"
          v-bind:class="[disableRow(item),(index%2==0?'even':'')]"
        >
          <td class="text-center">
            <input
              type="checkbox"
              :id="item.ams_campaign_id"
              :value="item.ams_campaign_id"
              v-model="item.checked"
              @change="selected(item)"
            />
          </td>
          <td>
            <div
              style="width: 20px; border-radius: 10px; height: 20px"
              :class="color(item.state)"
            ></div>
          </td>
          
          <td
            v-if="item.state == 'enabled' || item.state == 'Enabled'"
            style="word-wrap: break-word; max-width: 180px"
          >
            <a
              href="javascript:void(0)"
              style="color: #333"
              @click="navigateToCampaignDetail(item)"
            >
              {{ item.name }}
              <sup style="color: orange; font-size: 12px">{{
                getSponsoredType(item.campaign_type)
              }}</sup>
              <!-- item.campaign_type=='sponsoredBrands'?'sb':(item.campaign_type=='sponsoredProducts'?'sp':"")}} -->
            </a>
            <br />
            <span v-if="$store.state.isUserPrestige">
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Brand Tag'" v-if="item.brand_tag" style="margin:2px" class="label label-info">{{item.brand_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Strategy Tag'" v-if="item.strategy_tag" style="margin:2px" class="label label-info">{{item.strategy_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Country Tag'" v-if="item.country_tag" style="margin:2px" class="label label-info">{{item.country_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Segment Tag'" v-if="item.segment_tag" style="margin:2px" class="label label-info">{{item.segment_tag}}</span>
            </span>
          </td>
          <td
            v-else-if="item.state == 'paused' || item.state == 'Paused'"
            style="word-wrap: break-word; max-width: 180px"
          >
            <a
              href="javascript:void(0)"
              style="color: #333"
              @click="navigateToCampaignDetail(item)"
            >
              {{ item.name }}
              <sup style="color: orange; font-size: 12px">{{
                getSponsoredType(item.campaign_type)
              }}</sup>
              <!-- item.campaign_type=='sponsoredBrands'?'sb':(item.campaign_type=='sponsoredProducts'?'sp':"")-->
            </a>
            <br />
            <span v-if="$store.state.isUserPrestige">
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Brand Tag'" v-if="item.brand_tag" style="margin:2px" class="label label-info">{{item.brand_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Strategy Tag'" v-if="item.strategy_tag" style="margin:2px" class="label label-info">{{item.strategy_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Country Tag'" v-if="item.country_tag" style="margin:2px" class="label label-info">{{item.country_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Segment Tag'" v-if="item.segment_tag" style="margin:2px" class="label label-info">{{item.segment_tag}}</span>
            </span>
            
          </td>
          <td v-else style="word-wrap: break-word; max-width: 180px">
            <a
              href="javascript:void(0)"
              style="color: #333"
              @click="navigateToCampaignDetail(item)"
            >
              {{ item.name }}
              <sup style="color: orange; font-size: 12px"
                >{{ getSponsoredType(item.campaign_type) }}
              </sup>
              <!-- item.campaign_type=='sponsoredBrands'?'sb':(item.campaign_type=='sponsoredProducts'?'sp':"")}} -->
            </a>
            <br />
            <span v-if="$store.state.isUserPrestige">
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Brand Tag'" v-if="item.brand_tag" style="margin:2px" class="label label-info">{{item.brand_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Strategy Tag'" v-if="item.strategy_tag" style="margin:2px" class="label label-info">{{item.strategy_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Country Tag'" v-if="item.country_tag" style="margin:2px" class="label label-info">{{item.country_tag}}</span>
              <span data-toggle="tooltip" @mouseover="tooltipCode()" :title="'Segment Tag'" v-if="item.segment_tag" style="margin:2px" class="label label-info">{{item.segment_tag}}</span>
            </span>
          </td>
          <!-- <td>{{ {sponsoredproducts: 'SP', sponsoredbrands: 'SB', sponsoredtelevision: 'ST', sponsoreddisplay: 'SD', default: ''}[item.campaign_type ? item.campaign_type.toLowerCase() : 'default'] }}</td> -->
          <td>
            <span 
              v-if="item.tagged && !$store.state.isUserPrestige"
              v-for="tag in  item.tagged ? [].concat(
                item.tagged.filter(t => t.type === 'campaign_brand' ), 
                item.tagged.filter(t => t.type === 'campaign_category'), 
                item.tagged.filter(t => t.type === 'campaign_subcategory'), 
                item.tagged.filter(t => t.type === 'campaign_style'), 
                item.tagged.filter(t => t.type === 'campaign_tactic1'),
                item.tagged.filter(t => t.type === 'campaign_tactic2'), 
                item.tagged.filter(t => t.type === 'campaign_gl')) : []"
              data-toggle="tooltip"
              @mouseover="tooltipCode()"
              :title="`${tag.type.split('_')[1].replace('subcat','sub-cat')}`"
              class="label label-info"
              :style="`display: inline-block; padding: 5px; margin: 2px; background-color: ${getLabelTileColor(tag.type)};`"
              >{{ tag.title.toLowerCase() }}
            </span>
          </td>
          <td>{{ item.country_code }}</td>
          <td>
            {{ item.start_date ? moment(item.start_date).format("l") : "" }}
          </td>
          <!-- <td>{{ item.end_date ? moment(item.end_date).format("l") : "" }}</td> -->
          <td style="min-width: 115px !important">
            {{ item.daily_budget ? item.daily_budget : 0 }}
          </td>
          <!-- <td>{{ (item.total_impressions ? item.total_impressions : 0) }}</td>
					<td>{{ (item.total_clicks ? item.total_clicks : 0) }}</td>
					<td>{{ ((item.total_spend && item.total_clicks)? (parseFloat(item.total_spend) /parseFloat(item.total_clicks)).toPrecision(2) : 0) }}</td>
					<td>{{ (item.total_spend ? item.total_spend : 0) }}</td> 
					<td>{{ (item.total_sales ? item.total_sales : 0) }}</td>
					<td>{{ (item.daily_budget ? item.daily_budget : 0) }}</td> -->
          <td
            style="word-wrap: break-word; max-width: 120px"
            v-if="item.search_specialist_first || item.search_specialist_last"
          >
            {{ item.search_specialist_first + ' ' + item.search_specialist_last }}
          </td>
          <td v-else></td>
          <td
            v-if="
              item.start_date_ams && (!item.disabled || item.disabled == null)
            "
          >
            <button
              v-bind:class="colorFlag(item)"
              disabled="true"
              style="background-color: rgb(117, 199, 145); display: inline-flex"
            >
              AMSO
              <i
                v-if="checkScheduled(item.start_date_ams) == false"
                class="fa fa-calendar"
                style="color: rgb(255, 255, 255, 0.5);padding: 3px 0 0 5px;"
              ></i>
            </button>
          </td>

          <td
            v-else-if="
              (item.start_date_ml || item.start_date_midnight) &&
              (!item.disabled || item.disabled == null)
            "
          >
            <button
              v-if="item.start_date_ml"
              disabled="true"
              v-bind:class="colorFlag(item)"
              style="background-color: rgb(232, 210, 174); display: inline-flex"
            >
              MLSO
              <i
                v-if="checkScheduled(item.start_date_ml) == false"
                class="fa fa-calendar"
                style="color: rgb(255, 255, 255, 0.5); padding: 3px 0 0 5px;"
              ></i>
            </button>
            <button
              v-if="item.start_date_midnight"
              disabled="true"
              v-bind:class="colorFlag(item)"
              style="background-color: rgb(255, 102, 153); display: inline-flex"
            >
              {{ item.shutoff_for == "day_parting" ? "DP" : "MNSO" }}
              <i
                v-if="checkScheduled(item.start_date_midnight) == false"
                class="fa fa-calendar"
                style="color: rgb(255, 255, 255, 0.5); padding: 3px 0 0 5px;"
              ></i>
            </button>
          </td>
          <td
            v-else-if="
              item.state == 'archived' &&
              !item.start_date_ml &&
              !item.start_date_midnight &&
              !item.start_date_ams
            "
          >
            <button
              v-bind:class="colorFlag(item)"
              disabled="true"
              style="background-color: #ccc"
            >
              Archived
            </button>
          </td>
          <td
            v-else-if="
              (!item.disabled || item.disabled == null) &&
              !item.start_date_ml &&
              !item.start_date_midnight &&
              !item.start_date_ams
            "
          >
          </td>
          <td
            v-else-if="
              item.disabled &&
              !item.start_date_ml &&
              !item.start_date_midnight &&
              !item.start_date_ams
            "
          >
            <button
              v-bind:class="colorFlag(item)"
              disabled="true"
              style="background-color: #3da3a7"
            >
              Disabled
            </button>
          </td>
          <td
            v-else-if="
              item.disabled &&
              (item.start_date_ml ||
                item.start_date_midnight ||
                item.start_date_ams)
            "
          >
            <button
              v-bind:class="colorFlag(item)"
              disabled="true"
              style="background-color: #3da3a7"
            >
              Disabled
            </button>
          </td>
          <!-- <td v-if ="!item.ml_shutoff && !item.ams_shutoff &&  !item.midnight_shutoff"><button class="mnsoFlagStyle go-popover-mnso btn btn-primary" @click="showMnsoPopup()" :disabled = "!$route.params.groupId" >Set ShutDown</button></td> -->
          <!-- <td v-if = "item.disabled"></td> -->
          <td
            v-if="!item.disabled || item.disabled == null"
          >
          <div class="row-add-edit">
            <a
              href="javascript:void(0)"
              class="item-add-edit"
              data-toggle="dropdown"
            ></a>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
              style="left: -58px"
            >
              <a
                class="grid-item ico-edit"
                @click="navigateToAddEditCampaign(item)"
                >Edit</a
              >
              <a
                class="grid-item ico-delete"
                href="javascript:void(0)"
                @click="deleteCampaign(item)"
                >Delete</a
              >
              <a
                class="grid-item ico-power-off"
                href="javascript:void(0)"
                @click="showMnsoPopup(item)"
                >Manage ShutOff</a
              >
              <a
                class="grid-item ico-activity"
                href="javascript:void(0)"
                @click="viewActivityPage(item.campaign_id, item.name)"
                >View Activity</a
              >

              <!-- <a
								class="grid-item ico-power-off"
								href="javascript:void(0)"
								@click="showDayPartingPopUp(item.campaign_id,item.name)"
							>Manage Day Parting</a> -->
              <a
                class="grid-item ico-recommended"
                v-if="
                  item.targeting_type == 'manual' &&
                  item.campaign_type == 'sponsoredProducts' &&
                  item.ams_campaign_id
                "
                href="javascript:void(0)"
                @click="
                  viewKeywordRecommendPage(
                    item.campaign_id,
                    item.ams_campaign_id,
                    item.name,
                    item.profile_id,
                    item.campaign_type,
                    item.ams_profile_id,
                    'recommended'
                  )
                "
                >Keyword Recommendation</a
              >
              <a
                class="grid-item ico-recommended"
                v-else-if="
                  item.ams_campaign_id &&
                  item.campaign_type != 'sponsoredDisplay'
                "
                href="javascript:void(0)"
                @click="
                  viewKeywordRecommendPage(
                    item.campaign_id,
                    item.ams_campaign_id,
                    item.name,
                    item.profile_id,
                    item.campaign_type,
                    item.ams_profile_id,
                    'exact'
                  )
                "
                >Keyword Recommendation</a
              >
              <a
                class="grid-item ico-activity"
                href="javascript:void(0)"
                @click="AddGuardrail(item)"
                >Create Guardrail</a
              >
            </div>
          </div>
          </td>
          <td v-else></td>
          <!-- <td>&nbsp;</td> -->
        </tr>
      </tbody>
    </table>
    <NoDataAvailable
      displayMessage="No Data Is Available"
      v-else
    ></NoDataAvailable>
    <MNSOFlagPopUp
      ref="mnsFlagPopup"
      :list="listObj"
      v-if="showModal"
      @hideMSOModal="hideMSOModal"
      @closeMSOModal="closeMSOModal"
    />
    <DeletePopUp
      v-if="isDeletePopUp"
      :headerMssg="updateHeading(delPayload.name)"
      @deleteData="deleteData"
      @hideDeleteModal="hideDeleteModal"
    />
  </div>
  <!-- <div class="iframe-wrapper">
        <iframe src="http://localhost:8082/campaign_group.html" frameborder="0" height="100%" width="100%"></iframe>
	</div>-->
</template>

<script>
import MNSOFlagPopUp from "./MNSOFlagPopUp";
import DeletePopUp from "../delete/DeletePopUp.vue";
import NoDataAvailable from "../NoDataAvailable.vue";
import moment from "moment";
export default {
  name: "CampaignGridList",
  components: {
    MNSOFlagPopUp,
    DeletePopUp,
    NoDataAvailable,
  },
  data() {
    return {
      checkedID: [],
      listObj: {},
      showModal: false,
      isDeletePopUp: false,
      delPayload: {},
      currentPath: "",
    };
  },
  props:['campaignList'],
  computed: {
    isShowAddToCampaigngroup() {
      return this.$store.state.selectedVendorFilter ? true : false;
    },
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
    campaignToAddToGroupList: {
      set(val) {
        this.$store.state.campaign.campaignToAddToGroupList = val;
      },
      get() {
        if (this.$store.state.campaign.campaignToAddToGroupList.length == 0) {
          this.resetSelectAllCampaign();
        }
        return this.$store.state.campaign.campaignToAddToGroupList;
      },
    },
    campaignSelectedList: {
      set(val) {
        this.$store.state.campaign.campaignSelectedList = val;
      },
      get() {
        if (this.$store.state.campaign.campaignSelectedList.length == 0) {
          this.resetSelectAllCampaignData();
        }
        return this.$store.state.campaign.campaignSelectedList;
      },
    },
    actionSelectionControl: {
      set(val) {
        this.$store.state.campaign.actionSelectionControl = val;
        if (val) {
          this.selectAllCampaign();
          this.selectAllDataForCampaign();
        } else {
          this.resetSelectAllCampaign();
          this.resetSelectAllCampaignData();
        }
      },
      get() {
        return this.$store.state.campaign.actionSelectionControl;
      },
    },
  },
  watch: {
    campaignToAddToGroupList() {},
    // checkedID(){
    //
    // if(this.checkedID.length){
    // 	this.$store.state.campaign.campaignToAddToGroupList = this.checkedID
    // //	this.$emit("campaignToAddToGroupList",this.checkedID)
    // }
    // }
  },
  mounted() {
    this.currentPath = this.$route.name;
    if (this.currentPath == "campaignListPerGroup") {
      this.$store.state.campaign.currentCampaignPath = "campaignListPerGroup";
    }
  },
  methods: {
    moment,
    getLabelTileColor(campaignLabelType) {
      let color =  {
        campaign_brand: '#2F5BC2', // Brand: Cobalt #2F5BC2
        campaign_category: '#1C919E', // Category: Peacock #1C919E
        campaign_subcategory: '#D98F34', // Sub-Category: Ochre #D98F34
        campaign_tactic1: '#60AEF7', // Tactic 1: Robin #60AEF7
        campaign_tactic2: '#C94024', // Tactic 2: Lantern #C94024
        campaign_style: '#6A61BA', // Style: Lavender #6A61BA
        campaign_gl: '#5E5E5E', // GL: Pewter #5E5E5E
      }[campaignLabelType]

      return color
    },
    getSponsoredType(data) {
      if (data == "sponsoredBrands") {
        return "sb";
      } else if (data == "sponsoredProducts") {
        return "sp";
      } else if (data == "sponsoredDisplay") {
        return "sd";
      } else if (data == "sponsoredTv") {
        return "st";
      }
      return "";
    },
    updateHeading(data) {
      if (data && data != "") {
        data = 'Delete "' + data + '"';
        return data;
      } else {
        return "Delete";
      }
    },
    resetCampAction() {
      this.$store.state.campaign.actionSelectionControl = false;
      this.$store.state.campaign.campaignSelectedList = [];
      this.$store.state.campaign.campaignToAddToGroupList = [];
    },
    tooltipCode() {
      $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    checkIsJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    parseTag(tags) {
      let data = tags.split(",");
      return data[0];
    },
    getToolTipData(tags) {
      let data = tags.split(",");
      data.splice(0, 1);
      data = data.join(",");
      // if(this.checkIsJson(tags)){
      // 	var str =''
      // 	tags = JSON.parse(tags)
      // 	for(var i=1;i<tags.length;i++){
      // 		str = str + tags[i].title
      // 		if(i != tags.length-1){
      // 			str = str	+ ',	'
      // 		}
      // 	}
      return data;
      // }
      // else {
      // 	if(str == "" || str == null || str == 'null'){
      // 		return ''
      // 	}
      // 	else if(str.length){
      // 		return str
      // 	}
      // }
    },
    color(state) {
      const stateLower = state ? state.toLowerCase() : ''
      return stateLower === "enabled"
        ? "green"
        : stateLower === "paused"
        ? "orange"
        : "grey";
    },
    viewKeywordRecommendPage(
      campId,
      amsCampId,
      campName,
      brand_id,
      campaign_type,
      amsProfileId,
      type
    ) {
      let list = this.$store.state.brandProfileList;
      // let amsProfileId = list.find(brand => {
      // 	return brand.id == brand_id;
      // });
      if (!amsProfileId) {
        alert("No brand profile !");
      } else {
        this.$router.push({
          path:
            "/recommendKeyword/" +
            campId +
            "/" +
            amsCampId +
            "/" +
            amsProfileId +
            "/" +
            campaign_type +
            "/" +
            btoa(campName) +
            "/" +
            type,
        });
      }
    },
    viewActivityPage(campId, campName) {
      this.$router.push({
        path: "/activityList/campaign/" + campId + "/" + btoa(campName),
      });
    },
    sorting(field, event) {
      this.resetCampAction();
      if (
        event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
        event.currentTarget.children[0].classList[2] == "fa-arrow-down"
      ) {
        var pastEvent = true;
      }
      for (var i = 0; i < document.getElementsByClassName("sort").length; i++) {
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-up");
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-down");
      }
      if (pastEvent) {
        this.sort.order == "desc"
          ? event.currentTarget.children[0].classList.add("fa-arrow-up")
          : event.currentTarget.children[0].classList.add("fa-arrow-down");
        pastEvent = false;
      } else {
        event.currentTarget.children[0].classList.add("fa-arrow-up");
      }
      this.sort = {
        field: field,
        order:
          event.currentTarget.children[0].classList[2] == "fa-arrow-up"
            ? "asc"
            : "desc",
      };

      // this.$store.state.sort.field = field;
      // this.$store.state.sort.order = (event.currentTarget.children[0].classList[2]) == 'fa-angle-up' ? 'asc':'desc';
    },
    colorFlag(item) {
      return "color-flag"
      if (item.disabled) {
        return "color-flag btn btn-primary";
      } else {
        return "btn btn-primary";
      }
    },
    checkScheduled(start_date) {
      let amsStDt = moment(start_date);
      let currentDate = moment(new Date());
      return currentDate.isSameOrAfter(amsStDt);
    },
    setStrategyColor(item) {
      if (
        (!item.disabled || item.disabled == null) &&
        item.strategy == "Sales"
      ) {
        return "tbl-badge sales";
      } else if (
        (!item.disabled || item.disabled == null) &&
        item.strategy == "ROI"
      ) {
        return "tbl-badge roi";
      } else if (
        item.disabled &&
        (item.strategy == "Sales" || item.strategy == "ROI")
      ) {
        return "tbl-badge disabled-sales";
      }
    },
    disableRow(item) {
      if (item.disabled) {
        return "disable-complete-row";
      }
    },
    navigateToAddEditCampaign(item) {
      let pathToRoute = "/addEditCampaign/" + item.campaign_id;
      if (this.$route.params && this.$route.params.groupId) {
        pathToRoute += "/" + this.$route.params.groupId;
      }
      this.$router.push({ path: pathToRoute });
    },
    deleteCampaign(item) {
      this.isDeletePopUp = true;
      this.delPayload = {
        id: item.campaign_id,
        ams_campaign_id: item.ams_campaign_id,
        name: item.name,
      };
    },
    navigateToCampaignDetail(item) {
      if (this.$route.name == "campaignListPerGroup") {
        this.$store.state.searchFilterString = "";
        this.$store.state.selectedBrandProfle = item.ams_profile_id;
        if (this.$store.state.selectedBrandProfle) {
          this.$store.state.selectedCampaignGroupFilter = item.campaignGroupId;
        } else {
          this.$store.state.selectedCampaignGroupFilter = "";
        }
        // let amsId =  this.$store.state.profileBrandList.filter(e=> {
        // if(e.id == this.$store.state.selectedBrandProfle){
        // 		return e.ams_profile_id
        // 	}
        // })
        // this.$store.state.selectedBrandProfle = (amsId && amsId.length) ? amsId[0].ams_profile_id : ''
        // if(!this.$store.state.selectedBrandProfle){
        // 	this.$store.state.selectedCampaignGroupFilter =  ""
        // }
        this.$store.state.refreshCampaign = true;
        sessionStorage.setItem(
          "campaign:showPerPage",
          this.$store.state.tempCampGrpShowPerPage || 25
        );
        this.$store.state.tempCampGrpShowPerPage = 25;
      } else {
        this.$store.state.refreshCampaign = false;
      }
      // let type =
      // 	item.campaign_type == "sponsoredProducts"
      // 		? "sp"
      // 		: item.campaign_type == "sponsoredBrands"
      // 		? "sb"
      // 		: "null";
      let type = this.getSponsoredType(item.campaign_type);
      type = type ? type : null;
      this.$router.push({
        path:
          "/KeywordDetail/" +
          item.campaign_id +
          "/" +
          item.ams_campaign_id +
          "/" +
          type +
          "/" +
          btoa(item.name) +
          "/" +
          item.daily_budget,
      });
      //this.$router.push({ path: '/CampaignDetail/' + item.ams_campaign_id + '/' + item.name })
    },
    deleteData() {
      let vm = this;
      delete this.delPayload["name"];
      this.$store
        .dispatch("campaign/deleteCampaign", this.delPayload)
        .then((res) => {
          vm.isDeletePopUp = false;
          vm.resetCampAction();
          vm.fetchList();
        });
    },
    fetchList() {
      let vm = this;
      let payload = {};
      if (vm.$route.params.groupId) {
        payload.selecteCampaignGropuId = vm.$route.params.groupId;
      }
      vm.$store.dispatch("campaign/getCampaignList", payload).then((res) => {
        console.log("Deleted");
      });
    },
    hideDeleteModal(data) {
      delete this.delPayload["name"];
      this.isDeletePopUp = false;
    },

    selected(item) {
      let data = this.$store.state.campaign.campaignToAddToGroupList;
      let data2 = this.$store.state.campaign.campaignSelectedList;
      if (item.checked) {
        data.push(item.campaign_id);
        data2.push(item);
      } else {
        let index = data.indexOf(item.campaign_id);
        let index2 = data2.indexOf(item);
        if (index > -1) {
          data.splice(index, 1);
        }

        if (index2 > -1) {
          data2.splice(index, 1);
        }

        this.$store.state.campaign.actionSelectionControl = false;
      }
    },
    resetSelectAllCampaign() {
      let data = JSON.parse(JSON.stringify(this.campaignList));
      data.forEach((element) => {
        element.checked = false;
      });
      this.campaignList = JSON.parse(JSON.stringify(data));
      this.campaignToAddToGroupList = [];
    },
    resetSelectAllCampaignData() {
      let data = JSON.parse(JSON.stringify(this.campaignList));
      data.forEach((element) => {
        element.checked = false;
      });
      this.campaignList = JSON.parse(JSON.stringify(data));
      this.campaignSelectedList = [];
    },
    selectAllCampaign() {
      this.campaignToAddToGroupList = [];
      let data = JSON.parse(JSON.stringify(this.campaignList));
      let vm = this;
      data.forEach((element) => {
        element.checked = true;
        vm.campaignToAddToGroupList.push(element.campaign_id);
      });

      this.campaignList = JSON.parse(JSON.stringify(data));
    },
    selectAllDataForCampaign() {
      this.campaignSelectedList = [];
      let data = JSON.parse(JSON.stringify(this.campaignList));
      let vm = this;
      data.forEach((element) => {
        element.checked = true;
        vm.campaignSelectedList.push(element);
      });
      this.campaignList = JSON.parse(JSON.stringify(data));
    },
    showMnsoPopup(item) {
      this.listObj = item;
      this.showModal = true;
    },
    hideMSOModal(val) {
      this.resetCampAction();
      this.showModal = false;
      this.fetchList();
    },
    closeMSOModal() {
      this.showModal = false;
    },
    AddGuardrail(data) {
      this.openGuardrail(data)
    },
    openGuardrail(data){
      this.campaignToAddToGroupList = [];
      this.campaignSelectedList = [];
      this.campaignToAddToGroupList.push(data);
      this.campaignSelectedList.push(data);
      this.$router.push({
        path: '/addEditGuardrail/' + 'null' + '/myAutomation' + '/campaign'
      });
    }
  },
};
</script>

<style lang="scss">
.add-product-wrap {
  cursor: pointer;
  color: white;
  background: green;
}
.iframe-wrapper {
  width: 100%;
  height: calc(100vh + 150px);
  position: relative;
  top: -120px;
}
.mnsoFlagStyle {
  background-color: teal !important;
  -webkit-appearance: none !important;
}
.btn-primary {
  // border: 0px transparent solid !important;
  margin: 5px !important;
}
.color-flag {
  color: #fff !important;
  background-color: #1d919e !important;
  padding: 5px 10px;
  border: 1px solid #1d919e;
  border-radius: 3px;
  opacity: 1;
  margin: 5px!important;
}
.disabled-sales {
  border: 1px #a5a5a5 solid;
  background-color: #e8e8e8;
  color: #a9a9a9;
}
.disable-complete-row {
  background-color: #f5f5f5;
}
.green {
  background: green;
}
.orange {
  background: #ffaa1d;
}
.grey {
  background: #cccccc;
}
</style>
